import { getOrdersOrderIdPaymentDetail } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { UserPermissions } from "Infrastructure/Api/permissions";
import { hasPermission } from "Infrastructure/Utilities/Permissions/hasPermission";
import { useQuery } from "@tanstack/react-query";

export const getOrderPaymentDetailQueryKey = (orderId: number) => [
	"ORDER_PAYMENT_DETAIL",
	orderId,
];

export function useOrderPaymentDetailQuery(orderId: number) {
	return useQuery({
		queryKey: getOrderPaymentDetailQueryKey(orderId),
		queryFn: processResponse(() => getOrdersOrderIdPaymentDetail(orderId)),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled:
			!!orderId && hasPermission(UserPermissions.OrderPaymentDetailModule.read),
	});
}
